import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

class SvgSpriteLoader extends React.Component {
  componentDidMount() {
    const { url } = this.props;
    const existingSpriteNode = document.querySelector(`[data-sprite="${url}"]`);
    if (existingSpriteNode) {
      this.props.onLoad();
      return;
    }
    axios.get(this.props.url).then(response => {
      const div = document.createElement('div');
      div.setAttribute('data-sprite', url);
      div.setAttribute('style', 'display: none');
      div.innerHTML = response.data;
      document.body.insertBefore(div, document.body.childNodes[0]);
      this.props.onLoad();
    });
  }

  render() {
    return null;
  }
}

SvgSpriteLoader.propTypes = {
  onLoad: PropTypes.func,
  url: PropTypes.string.isRequired
};

SvgSpriteLoader.defaultProps = {
  onLoad: () => {}
};

export default SvgSpriteLoader;



// WEBPACK FOOTER //
// ./src/components/SvgSpriteLoader/index.js